import { createClient } from '@supabase/supabase-js'

// Usar variables de entorno para mayor seguridad y flexibilidad
const defaultSupabaseUrl = 'https://qnmgoffoptpijfxpotbg.supabase.co'
const defaultSupabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFubWdvZmZvcHRwaWpmeHBvdGJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3MjQ1ODYsImV4cCI6MjA4MDMwMDU4Nn0.BF_RF4E2hd-dB0AqwSF14Dm8TwLJ9cGyvKH1SiRNisA'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || defaultSupabaseUrl
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || defaultSupabaseKey
export const SUPABASE_REALTIME_DISABLED = true
export const SUPABASE_BACKGROUND_POLLING_DISABLED = true

if (!supabaseUrl || !supabaseKey) {
    console.error(
        'Faltan variables de entorno de Supabase (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY)'
    )
} else {
    // Health Check Logs (Development Only)
    console.log('[Supabase] Initializing client...')
    console.log('[Supabase] URL:', supabaseUrl)
    console.log('[Supabase] Key Length:', supabaseKey?.length)
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
    }
})

export const cleanupSupabaseChannel = async (channel) => {
    if (!channel) return

    try {
        if (typeof channel.unsubscribe === 'function') {
            await channel.unsubscribe()
        }
    } catch (error) {
        console.warn('[Supabase] Error unsubscribing channel:', error)
    }

    try {
        if (typeof supabase.removeChannel === 'function') {
            await supabase.removeChannel(channel)
        }
    } catch (error) {
        console.warn('[Supabase] Error removing channel:', error)
    }
}

if (SUPABASE_REALTIME_DISABLED) {
    const disabledRealtimeChannel = {
        on() {
            return this
        },
        subscribe() {
            return {
                unsubscribe() {}
            }
        },
        unsubscribe() {}
    }

    supabase.channel = () => disabledRealtimeChannel
    supabase.removeChannel = async () => ({ data: null, error: null })
    supabase.removeAllChannels = async () => ({ data: null, error: null })
    console.warn('[Supabase] Realtime disabled by emergency runtime guard')
}
